module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ef-Ga.7b347955.png";